import { VideoColorFinderJob } from "@nova/protobuf"
import { generateGenericCases } from "../../generateCases"
import { Builder } from "../../sockets"
import {
    CreateVideoColorFinderJobArgs,
    getDefaultVideoColorFinderJobCreateArgs,
    UpdateVideoColorFinderJobArgs,
} from "@nova/serializer/src/client/validators/jobs/videoColorFinder"
import { addEntitySocket, updateEntitySocket } from "features/entity-caching/project/slice"
import { selectActivatedFireId } from "features/map/control/selectors"
import { selectActiveWorkspace } from "features/data-management/workspace/WorkspaceManagementSlice"

const {
    create: createVideoColorFinderJob,
    update: updateVideoColorFinderJob,
    createAction,
    updateAction,
    deleteAction,
} = generateGenericCases<
    VideoColorFinderJob, // entity type
    CreateVideoColorFinderJobArgs, // create args to send to server
    [
        "srtPath",
        "videoPath",
        "metadataPath",
        "colordataPath",
        "numFrames",
        "cumulativeColorIndex",
        "anomalyPath",
    ], // create args required by action
    UpdateVideoColorFinderJobArgs, // update args
    { file?: string; flightId: string }, // context required by action
    {
        flightId: string
        file?: string
        portfolioName?: string
        portfolioId?: string
        projectId?: string
    } // context required by server
>("VideoColorFinderJob")

export const addVideoColorFinderJobsToBuilder = (builder: Builder) =>
    builder
        .addCase(createAction, (store, { payload: { data, context } }, socket) => {
            if (!context?.file || !context.flightId) throw "Missing file or flightId"

            const state = store.getState()
            const projectId = selectActivatedFireId(state)!
            const org = selectActiveWorkspace()(state)!
            const serverContext = {
                file: context.file,
                flightId: context.flightId,
                portfolioName: org.name,
                portfolioId: org.id,
                projectId,
            }
            createVideoColorFinderJob(socket, data, serverContext)
            store.dispatch(
                addEntitySocket({
                    data: { ...data, ...getDefaultVideoColorFinderJobCreateArgs() },
                    path: ["videoColorFinderFlights", { id: context.flightId }, "job"],
                })
            )
        })
        .addCase(updateAction, (store, { payload: { updates, context } }, socket) => {
            updateVideoColorFinderJob(socket, context.flightId, updates, {
                flightId: context.flightId,
            })
            store.dispatch(
                updateEntitySocket({
                    updates,
                    path: ["videoColorFinderFlights", { id: context.flightId }, "job"],
                })
            )
        })

export {
    createAction as createVideoColorFinderJob,
    updateAction as updateVideoColorFinderJob,
    deleteAction as deleteVideoColorFinderJob,
}
